import { useSupplierProductMetrics } from '@/services'
import { Skeleton, Text } from '@mercai/clever'
import { useTranslation } from 'react-i18next'
import { CardMetric } from './components'

import styles from './metrics.module.css'

export const Metrics = () => {
  const { t } = useTranslation('screenSuppliers')

  const { data, isLoading } = useSupplierProductMetrics()

  return (
    <div>
      <CardMetric
        title={t('metricsConsumptionOfProductsTitle')}
        information={
          <div className={styles.information}>
            {!isLoading ? (
              <>
                <Text variant="text-large-bold">
                  {data?.data?.totalQuantityUsed} kg
                </Text>

                <Text variant="text-medium">
                  /{data?.data?.totalQuantity} kg
                </Text>
              </>
            ) : (
              <Skeleton width={'100%'} height={'1.8rem'} />
            )}
          </div>
        }
      />
    </div>
  )
}
